import {classAdderBuilder} from '@smui/common/classAdderBuilder.js';
import H2 from '@smui/common/H2.svelte';

export default classAdderBuilder({
  class: 'mdc-dialog__title',
  component: H2,
  contexts: {}
});